import styled from '@emotion/styled'

import theme from 'styles/theme'

export const CartWrapper = styled.div<{ marginTopOnMobile?: string }>`
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  background: ${theme.token.var('colors.white')};
  padding: 26px 0;
  max-width: 900px;
  margin: 0 auto 28px auto;

  @media (min-width: ${theme.token('breakpoints.md')}) {
    margin-top: 40px;
    min-height: 70vh;
  }
`

export const SummaryBox = styled.div`
  width: 100%;
  padding: 22px 18px 18px 18px;
  background-color: ${theme.token.var('colors.green.a200')};
  border-radius: ${theme.token.var('borderRadius.big')};
  color: ${theme.token.var('colors.white')};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
`
